export default {
  sections: {
    address: 'Dirección',
    legal_address: 'Dirección de registro',
    invoice_address: 'Dirección de facturación',
  },
  form: {
    display_name: {
      label: 'Nombre amigable',
      placeholder: 'Introduzca el nombre amigable de la empresa',
    },
    legal_name: {
      label: 'Nombre legal',
      placeholder: 'Introduzca el nombre legal',
      tooltip: 'Nombre de registro. Se muestra en informes de pagos, contrato, etc.',
    },
    timezone: {
      label: 'Zona horaria',
    },
    has_dedicated_invoice_address: {
      label: 'Datos de facturación distintos',
    },
  },
  buttons: {
    next: 'Siguiente',
  },
};
